import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=138595cf&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"
import style0 from "./experience.vue?vue&type=style&index=0&id=138595cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138595cf",
  null
  
)

export default component.exports